enum BrowserErrors {
  Cancel = 'Cancel',
}

export default BrowserErrors;
